// Homepage Gacha bundle v2 (sections/ssc-gacha.liquid, prompt 85; v1 prompt 76). Data, size keys, offer maths and the add
// path are shared with the cart picks in assets/ssc-pool.js. A pull = one real product in the chosen size, from every product
// type of the section's config, in stock in that size at the US warehouse (ships in 24h; no made-to-order and no pre-order
// sizes, 85), not on the section's leave-out list, not pulled before in this set, not kept, not in the cart. Weight =
// best-selling rank × 1.3 when 1–3 are left. The pulls that will be free prefer items priced at most the cheapest kept one.
// The pull opens inside the globe; prices follow the honesty rule (FREE only when the set really frees it); the drawer total is
// always Shopify's own discount. The set survives a reload.
(function () {
  var root = document.querySelector('[data-ssc-gacha]');
  if (!root || !window.SSCPool) return;
  var P = window.SSCPool;
  var G = P.GROUP;
  var BUY = P.BUY;
  var GET = P.GET;
  var STORE = 'ssc-gacha-v1';
  var SIZES = ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl'];
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-g-config]').textContent); } catch (e) {}
  var TYPES = cfg.types || {};
  var SKIP = (cfg.skip || []).map(function (h) { return String(h).trim(); }).filter(Boolean);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = P.esc;
  var money = P.money;

  var el = {
    globe: root.querySelector('[data-g-globe]'),
    pile: root.querySelector('[data-g-pile]'),
    pick: root.querySelector('[data-g-pick]'),
    info: root.querySelector('[data-g-info]'),
    acts: root.querySelector('[data-g-acts]'),
    left: root.querySelector('[data-g-left]'),
    chute: root.querySelector('[data-g-chute]'),
    slots: root.querySelector('[data-g-slots]'),
    tot: root.querySelector('[data-g-tot]'),
    add: root.querySelector('[data-g-add]'),
    live: root.querySelector('[data-g-live]')
  };

  // phase: idle | shake (machine running) | loading (waiting for the data before a pull)
  var S = { size: null, kept: [], seen: [], current: null, phase: 'idle', next: null, empty: false, added: false, err: '' };
  try {
    var saved = JSON.parse(sessionStorage.getItem(STORE) || 'null');
    if (saved && Array.isArray(saved.kept)) { S.size = saved.size || null; S.kept = saved.kept.slice(0, G); S.seen = saved.seen || []; S.current = saved.current || null; }
  } catch (e) {}
  function save() {
    try { sessionStorage.setItem(STORE, JSON.stringify({ size: S.size, type: 'any', kept: S.kept, seen: S.seen, current: S.current })); } catch (e) {}
  }

  // ---------- data ----------
  var lists = null;
  var loading = null;
  var inCart = null;
  function loadAll() {
    if (loading) return loading;
    loading = Promise.all(Object.keys(TYPES).map(function (h) {
      return P.load(h).then(function (list) { return [h, list]; }).catch(function () { return [h, []]; });
    })).then(function (pairs) {
      lists = {};
      pairs.forEach(function (pr) { lists[pr[0]] = pr[1]; });
      render();
    });
    return loading;
  }
  function cartHandles() {
    if (inCart) return Promise.resolve(inCart);
    var st = window.sscCartState;
    var use = function (cart) {
      inCart = {};
      (cart.items || []).forEach(function (l) { inCart[String(l.handle || '').replace(/-preorder$/, '')] = true; });
      return inCart;
    };
    if (st && st.cart) return Promise.resolve(use(st.cart));
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(use).catch(function () { inCart = {}; return inCart; });
  }
  document.addEventListener('ssc:cart', function (e) { if (e.detail && e.detail.cart) inCart = null; });

  function products() {
    var out = [];
    if (!lists) return out;
    Object.keys(lists).forEach(function (h) {
      lists[h].forEach(function (d, rank) { out.push({ d: d, type: h, rank: rank, n: lists[h].length }); });
    });
    return out;
  }
  function sizeOf(x) { return S.size ? x.d.s[S.size] : null; }
  function isReady(v) { return !!(v && v.rts); }
  function keyOf(x) { return x.type + ':' + x.d.h; }

  // ---------- picking ----------
  function keptPrices() { return S.kept.map(function (k) { return k.price; }); }
  function gainIf(price) { var k = keptPrices(); return P.discount(k.concat([price])) - P.discount(k); }
  // US warehouse stock only: a size counts when it is in stock (ready to ship), never a made-to-order or pre-order size.
  function readyIn(x, size) { var v = x.d.s[size]; return !!(v && v.rts) && SKIP.indexOf(x.d.h) === -1; }
  function readyCount(size) { return products().filter(function (x) { return readyIn(x, size); }).length; }
  function pool() {
    return products().filter(function (x) {
      var v = sizeOf(x);
      if (!v || !readyIn(x, S.size)) return false;
      if (S.seen.indexOf(keyOf(x)) !== -1) return false;
      if (S.kept.some(function (k) { return k.h === x.d.h; })) return false;
      return !(inCart && inCart[x.d.h]);
    });
  }
  function pick() {
    var list = pool();
    if (!list.length) return null;
    if (S.kept.length >= BUY) {
      var minKept = Math.min.apply(null, keptPrices());
      var cheap = list.filter(function (x) { return sizeOf(x).price <= minKept; });
      if (cheap.length) list = cheap;
    }
    var w = list.map(function (x) {
      var v = sizeOf(x);
      return Math.max(1, x.n - x.rank) * (isReady(v) && v.qty <= 3 ? 1.3 : 1);
    });
    var r = Math.random() * w.reduce(function (a, b) { return a + b; }, 0);
    for (var i = 0; i < list.length; i++) { r -= w[i]; if (r <= 0) return list[i]; }
    return list[list.length - 1];
  }
  function snapshot(x) {
    var v = sizeOf(x);
    return { key: keyOf(x), h: x.d.h, n: x.d.n, type: x.type, i: x.d.i, a: x.d.a, id: v.id, price: v.price, rts: v.rts, qty: v.qty, label: v.label, size: S.size };
  }

  // ---------- helpers ----------
  function up(s) { return String(s || '').toUpperCase(); }
  function ord(k) { var t = k % 100, u = k % 10; return k + (t >= 11 && t <= 13 ? 'th' : u === 1 ? 'st' : u === 2 ? 'nd' : u === 3 ? 'rd' : 'th'); }
  function worldOf(c) { return c && c.a ? c.a[1] || 'default' : 'default'; }
  // World icons already on the page: the globe's own capsules, then the homepage character select.
  function iconFor(world) {
    var src = root.querySelector('[data-g-ball="' + world + '"] svg') || document.querySelector('[data-cs="' + world + '"] .ssc-cs__ic svg') ||
      root.querySelector('[data-g-ball="default"] svg');
    return src ? src.outerHTML : '';
  }
  function typeName(type) { var l = TYPES[type] || ''; return /tee/i.test(l) ? l : l + ' shorts'; }
  // Shown right after a tap, always on screen: load at once (no lazy).
  function img(src, w, sizes, alt) {
    if (!src) return '';
    return '<img src="' + esc(P.imgAt(src, w)) + '" srcset="' + esc(P.imgAt(src, 150)) + ' 150w, ' + esc(P.imgAt(src, 300)) + ' 300w, ' + esc(P.imgAt(src, 450)) + ' 450w" sizes="' + sizes + '" alt="' + esc(alt || '') + '">';
  }
  function freeIdx() {
    if (S.kept.length < G) return [];
    return S.kept.map(function (k, i) { return [k.price, i]; }).sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; }).slice(0, GET).map(function (p) { return p[1]; });
  }
  function isFree(c) { var g = gainIf(c.price); return g > 0 && g >= c.price; }

  // ---------- render ----------
  function render() {
    var full = S.kept.length >= G;
    var c = S.current;
    var rev = !!c && S.phase === 'idle';

    // coins: a size with nothing ready right now is greyed and can't be picked
    root.querySelectorAll('[data-g-size]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.gSize === S.size ? 'true' : 'false');
      if (lists && !readyCount(b.dataset.gSize)) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
    // The scratch-to-reveal pop-up waits while a pull is open or a set is started (snippets/scratch-popup.liquid).
    if (S.current || S.phase !== 'idle' || S.kept.length) root.setAttribute('data-g-busy', ''); else root.removeAttribute('data-g-busy');

    // globe: pile, SFX, the open capsule
    el.pile.classList.toggle('is-dim', rev);
    el.globe.querySelectorAll('.ssc-g__open, .ssc-g__chip, .ssc-g__sfx, .ssc-g__tag').forEach(function (n) { n.remove(); });
    if (S.phase === 'shake' && !reduce) {
      el.pile.classList.remove('is-shake'); void el.pile.offsetWidth; el.pile.classList.add('is-shake');
      el.globe.insertAdjacentHTML('beforeend', '<span class="ssc-g__sfx" aria-hidden="true">ガチャ!</span>');
    }
    if (rev) {
      var w = worldOf(c);
      el.globe.insertAdjacentHTML('beforeend',
        '<div class="ssc-g__open' + (S.pop && !reduce ? ' is-pop' : '') + '" style="--g-w: var(--world-' + esc(w) + ')">' +
          img(c.i, 300, '(min-width: 990px) 200px, 160px', c.n + ' ' + typeName(c.type)) + '</div>' +
        (c.a ? '<span class="ssc-g__chip" style="--g-w: var(--world-' + esc(w) + ')">' + iconFor(w) + esc(c.a[0]) + '</span>' : '') +
        (isFree(c) ? '<span class="ssc-g__tag">FREE</span>' : ''));
      S.pop = false;
    }
    el.chute.innerHTML = S.phase === 'shake' && !reduce && S.next
      ? '<span class="ssc-g__drop" style="--g-w: var(--world-' + esc(worldOf(S.next)) + ')"></span>' : '';

    // coins ↔ the pull's details (same height)
    el.pick.hidden = rev;
    el.info.hidden = !rev;
    if (rev) {
      var free = isFree(c);
      el.info.innerHTML =
        '<span class="ssc-g__nm">' + esc(c.n) + '</span>' +
        '<span class="ssc-g__pr">' + (free ? '<s>' + money(c.price) + '</s> FREE' : money(c.price)) + '</span>' +
        '<span class="ssc-g__ty">' + esc(typeName(c.type)) + (cfg.wars && c.a ? ' · +1 vote ' + esc(c.a[0]) : '') + '</span>' +
        // Every pull is US warehouse stock; a set saved before 85 may still hold a made-to-order item.
        '<span class="ssc-g__st"><i class="ssc-g__dot' + (c.rts ? '' : ' is-mto') + '" aria-hidden="true"></i>' + (c.rts ? 'Ships in 24h from our US warehouse' : 'Made to order · 3–5 wks') + '</span>';
    }

    // Pull ↔ Keep it + Re-pull
    if (rev) {
      el.acts.innerHTML = '<button class="ssc-g__btn" type="button" data-g-keep>Keep it</button>' +
        '<button class="ssc-g__btn ssc-g__btn--ghost" type="button" data-g-repull>Re-pull</button>';
    } else {
      var on = false, label;
      if (!S.size) label = 'Pick your size ↑';
      else if (full) label = 'Bundle full ✓';
      else if (S.phase === 'shake') label = 'Pulling…';
      else if (S.phase === 'loading') label = 'Loading…';
      else if (S.empty || (lists && !readyCount(S.size))) label = 'No more ready in ' + up(S.size) + ' ↑';
      else { on = true; label = S.kept.length >= BUY ? 'Pull · this one’s free' : 'Pull'; }
      var btn = el.acts.querySelector('[data-g-pull]');
      if (!btn) {
        el.acts.innerHTML = '<button class="ssc-g__btn ssc-g__btn--wide" type="button" data-g-pull></button>';
        btn = el.acts.querySelector('[data-g-pull]');
      }
      btn.textContent = label;
      if (on) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
    }

    // footer right
    var left = G - S.kept.length;
    if (rev) el.left.innerHTML = 'Size ' + esc(up(c.size)) + ' · <button class="ssc-g__chg" type="button" data-g-change>change</button>';
    else if (S.note) el.left.textContent = S.note;
    else if (S.empty) el.left.textContent = 'Try another size';
    else el.left.textContent = full ? 'Bundle ready' : S.kept.length >= BUY ? (left === 1 ? 'Next pull is free' : 'Next pulls are free') : (G - S.kept.length) + ' pulls to a free item';

    renderTray();
  }

  function renderTray() {
    var fi = freeIdx();
    var full = S.kept.length >= G;
    var slots = '';
    for (var i = 0; i < G; i++) {
      var k = S.kept[i];
      var freeSlot = i >= BUY;
      if (!k) {
        slots += '<div class="ssc-g__slot' + (freeSlot ? ' is-free' : '') + '">' + (freeSlot ? ord(i + 1) + '<br>pull<span class="ssc-g__ft">FREE</span>' : 'Pull ' + (i + 1)) + '</div>';
        continue;
      }
      slots += '<div class="ssc-g__slot is-on" style="--g-w: var(--world-' + esc(worldOf(k)) + ')">' +
        img(k.i, 150, '(min-width: 990px) 84px, 54px', k.n + ' ' + typeName(k.type) + ', ' + up(k.size)) +
        '<button class="ssc-g__x" type="button" data-g-drop="' + i + '" aria-label="Remove ' + esc(k.n) + ' ' + esc(up(k.size)) + '">' +
          '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 1.5 L8.5 8.5 M8.5 1.5 L1.5 8.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        (fi.indexOf(i) !== -1 || (!full && freeSlot) ? '<span class="ssc-g__ft">FREE</span>' : '') + '</div>';
    }
    el.slots.innerHTML = slots;
    var sum = keptPrices().reduce(function (a, b) { return a + b; }, 0);
    var d = P.discount(keptPrices());
    el.tot.innerHTML = S.added && !S.kept.length
      ? '<button class="ssc-g__again" type="button" data-g-again>Pull another set</button>'
      : (full && d > 0 ? '<s>' + money(sum) + '</s>' : '') + money(sum - d);
    var b = el.add;
    if (b.getAttribute('aria-busy') === 'true') return;
    b.classList.toggle('is-done', S.added && !S.kept.length);
    if (S.added && !S.kept.length) { b.textContent = 'Added ✓'; b.setAttribute('aria-disabled', 'true'); }
    else if (full) { b.textContent = S.err ? 'Couldn’t add · try again' : 'Add ' + G + ' to cart'; b.removeAttribute('aria-disabled'); }
    else { b.textContent = (G - S.kept.length) + ' to go'; b.setAttribute('aria-disabled', 'true'); }
  }

  // ---------- actions ----------
  function doPull() {
    if (!lists) {
      S.phase = 'loading'; render();
      loadAll().then(function () { S.phase = 'idle'; doPull(); });
      return;
    }
    cartHandles().then(function () {
      var x = pick();
      S.current = null;
      S.added = false;
      if (!x) { S.empty = true; S.phase = 'idle'; save(); render(); el.live.textContent = 'No more designs ready in ' + up(S.size) + '. Try another size.'; return; }
      S.empty = false;
      S.next = snapshot(x);
      S.phase = 'shake';
      // Start the photo during the shake so it is usually there when the capsule opens.
      if (x.d.i) { var pre = new Image(); pre.sizes = window.innerWidth >= 990 ? '200px' : '160px'; pre.srcset = P.imgAt(x.d.i, 150) + ' 150w, ' + P.imgAt(x.d.i, 300) + ' 300w, ' + P.imgAt(x.d.i, 450) + ' 450w'; }
      render();
      setTimeout(function () {
        S.seen.push(keyOf(x));
        S.current = S.next;
        S.next = null;
        S.phase = 'idle';
        S.pop = true;
        save();
        render();
        var c = S.current;
        el.live.textContent = 'You pulled ' + c.n + ', ' + typeName(c.type) + ', ' + (c.rts ? 'ready to ship' : 'made to order') + ' in ' + up(c.size) + '.';
        var keep = root.querySelector('[data-g-keep]');
        if (keep) keep.focus({ preventScroll: true });
      }, reduce ? 0 : 700);
    });
  }
  function focusPull() { var b = root.querySelector('[data-g-pull]'); if (b) b.focus({ preventScroll: true }); }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t || !root.contains(t) || S.phase !== 'idle') return;
    if (t.dataset.gSize) {
      if (t.getAttribute('aria-disabled') === 'true') {
        S.note = 'Nothing ready in ' + up(t.dataset.gSize) + ' right now';
        el.live.textContent = S.note + '.';
        render();
        return;
      }
      S.size = t.dataset.gSize; S.current = null; S.seen = []; S.empty = false; S.added = false; S.note = '';
      loadAll(); save(); render(); return;
    }
    if (t.hasAttribute('data-g-again')) {
      S.added = false; S.seen = []; S.empty = false; S.note = ''; save(); render();
      focusPull();
      return;
    }
    if (S.note) { S.note = ''; render(); }
    if (t.hasAttribute('data-g-pull')) {
      if (t.getAttribute('aria-disabled') === 'true') {
        if (!S.size || S.empty) { var first = root.querySelector('[data-g-size]'); if (first) first.focus(); el.live.textContent = S.empty ? 'Try another size.' : 'Pick your size first.'; }
        return;
      }
      doPull(); return;
    }
    if (t.hasAttribute('data-g-keep') && S.current) {
      S.kept.push(S.current); S.current = null; S.err = ''; save(); render();
      el.live.textContent = S.kept.length >= G ? 'Set complete.' : 'Kept. ' + (G - S.kept.length) + ' to go.';
      if (S.kept.length >= G) el.add.focus({ preventScroll: true }); else focusPull();
      return;
    }
    if (t.hasAttribute('data-g-repull')) { doPull(); return; }
    if (t.hasAttribute('data-g-change')) {
      // Back to the coins; the current pull is dropped.
      S.current = null; save(); render();
      var on = root.querySelector('[data-g-size][aria-pressed="true"]') || root.querySelector('[data-g-size]');
      if (on) on.focus({ preventScroll: true });
      return;
    }
    if (t.dataset.gDrop) {
      var gone = S.kept.splice(+t.dataset.gDrop, 1)[0]; S.err = ''; S.added = false; save(); render();
      el.live.textContent = 'Removed ' + (gone ? gone.n : '') + '.';
      focusPull();
      return;
    }
    if (t.hasAttribute('data-g-add')) {
      if (t.getAttribute('aria-disabled') === 'true' || t.getAttribute('aria-busy') === 'true') return;
      t.setAttribute('aria-busy', 'true');
      t.textContent = 'Adding…';
      P.addToCart(S.kept.map(function (k) { return { id: k.id, quantity: 1, properties: { _src: 'gacha' } }; }), t, 'ssc-gacha')
        .then(function () {
          t.removeAttribute('aria-busy');
          S.kept = []; S.seen = []; S.current = null; S.err = ''; S.added = true; inCart = null;
          try { sessionStorage.removeItem(STORE); } catch (err) {}
          render();
          el.live.textContent = 'Added your gacha set to the cart.';
        })
        .catch(function () {
          t.removeAttribute('aria-busy');
          S.err = "Couldn't add, try again";
          render();
          el.live.textContent = "Couldn't add, try again.";
        });
    }
  });

  // Data only once the section is near the screen (or the moment a size is picked).
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); loadAll(); }
    }, { rootMargin: '300px 0px' });
    io.observe(root);
  } else {
    loadAll();
  }
  if (S.size || S.kept.length) loadAll();
  render();
})();
